<div class="row">
  <div class="col-xs-12 col-sm-6 col-sm-offset-3">
    <app-gallery-record-card *ngIf="record" [record]="record"></app-gallery-record-card>
  </div>
</div>
